import { type FC, type ReactNode } from 'react';

import './SubjectOnboardingFlow.css';

interface SubjectOnboardingFlowShellProps {
  checkpointConfig: ReactNode;
  checkpointSearch?: ReactNode;
  desktopCheckpointList: ReactNode;
  emptyStateMessage: string | null;
  hasConfiguration: boolean;
  header: ReactNode;
  isMobileViewport: boolean;
  mobileCheckpointList: ReactNode;
  subjectDetails?: ReactNode;
  subjectSelection: ReactNode;
  subjectStatus?: ReactNode;
}

const SubjectOnboardingFlowShell: FC<
  SubjectOnboardingFlowShellProps
> = ({
  checkpointConfig,
  checkpointSearch,
  desktopCheckpointList,
  emptyStateMessage,
  hasConfiguration,
  header,
  isMobileViewport,
  mobileCheckpointList,
  subjectDetails,
  subjectSelection,
  subjectStatus,
}) => (
  <div className="subject-onboarding-page flex h-full max-h-full flex-col gap-4 overflow-y-auto max-sm:h-auto max-sm:gap-3 max-sm:overflow-x-hidden">
    {header}
    <div className="flex flex-col gap-4 max-sm:gap-3">
      {subjectSelection}
      {subjectDetails}
      {hasConfiguration ? (
        <>
          {subjectStatus}
          {checkpointSearch}
          {emptyStateMessage ? (
            <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-6 text-sm text-gray-500">
              {emptyStateMessage}
            </div>
          ) : isMobileViewport ? (
            mobileCheckpointList
          ) : (
            desktopCheckpointList
          )}
        </>
      ) : null}
    </div>
    {checkpointConfig}
  </div>
);

export default SubjectOnboardingFlowShell;
